import React from "react";

function InfoItem({ label, value }) {
  return (
    <div className="p-3 rounded-3 border bg-light h-100">
      <small className="text-muted text-uppercase fw-bold" style={{ fontSize: 11 }}>
        {label}
      </small>
      <div className="fw-semibold mt-1">{value || "Not set"}</div>
    </div>
  );
}

function ParentViewModal({ parent, onClose, onEdit, onLinkStudent }) {
  if (!parent) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.45)" }}>
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content border-0 shadow">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div className="rounded-circle text-white fw-bold d-flex align-items-center justify-content-center" style={{ width: 56, height: 56, background: "#125b2d" }}>
                {parent.full_name?.split(" ").filter(Boolean).slice(0, 2).map((name) => name[0]).join("") || "PA"}
              </div>
              <div>
                <h5 className="modal-title fw-bold">{parent.full_name}</h5>
                <small className="text-muted">{parent.email}</small>
              </div>
            </div>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <div className="d-flex flex-wrap gap-2 mb-3">
              <span className={`badge ${parent.is_active ? "text-bg-success" : "text-bg-secondary"}`}>
                {parent.is_active ? parent.status || "ACTIVE" : "INACTIVE"}
              </span>
              <span className="badge text-bg-light border">
                {parent.linked_students_count || 0} linked student(s)
              </span>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-md-4"><InfoItem label="Phone" value={parent.phone} /></div>
              <div className="col-md-4"><InfoItem label="Occupation" value={parent.occupation} /></div>
              <div className="col-md-4"><InfoItem label="Employer" value={parent.employer} /></div>
              <div className="col-md-4"><InfoItem label="Work Phone" value={parent.work_phone} /></div>
              <div className="col-md-8"><InfoItem label="Address" value={parent.address} /></div>
              <div className="col-12"><InfoItem label="Notes" value={parent.relationship_notes} /></div>
            </div>

            <h6 className="fw-bold mb-3" style={{ color: "#125b2d" }}>Linked Students</h6>
            {parent.linked_students?.length ? (
              <div className="table-responsive">
                <table className="table table-sm align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Student</th>
                      <th>Number</th>
                      <th>Class</th>
                      <th>Relationship</th>
                      <th>Access</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parent.linked_students.map((link) => (
                      <tr key={link.link_id}>
                        <td className="fw-semibold">{link.student_name}</td>
                        <td>{link.student_number}</td>
                        <td>{link.current_class || "Not set"}</td>
                        <td>{link.relationship}</td>
                        <td>
                          {link.is_primary_contact && <span className="badge text-bg-success me-1">Primary</span>}
                          {link.can_receive_results && <span className="badge text-bg-light border me-1">Results</span>}
                          {link.can_receive_finance_alerts && <span className="badge text-bg-light border me-1">Finance</span>}
                          {link.can_collect_student && <span className="badge text-bg-light border">Collect</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="alert alert-light border">No students linked yet.</div>
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-light" onClick={onClose}>Close</button>
            <button className="btn btn-outline-success" onClick={() => onLinkStudent(parent)}>
              <i className="bi bi-link-45deg me-2"></i>
              Link Student
            </button>
            <button className="btn btn-success" onClick={() => onEdit(parent)}>
              <i className="bi bi-pencil-square me-2"></i>
              Edit Parent
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ParentViewModal;
